<template>
  <div class="analytics-result-container">
    <div class="navbar-header mt-4 border-bottom-dark px-4 pb-4">
      <div class="d-flex font-size-12 h-75">
        <i
          @click="$router.go(-1)"
          class="ri-arrow-left-line text-primary btn my-auto font-size-20 pl-0 py-0"
        ></i>
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="mb-0 font-size-32 text-primary">{{ "Result" }}</h2>
        </div>
      </div>
      <div>
        <div class="d-flex">
          <VueMultiselect
            v-if="rendermonth"
            style="width: 150px; padding-left: 15px"
            v-model="selectedMonth"
            placeholder="Month"
            tag-placeholder=""
            :options="filteredOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            :show-pointer="true"
            :show-arrow="true"
            @select="handleSelect"
          >
          </VueMultiselect>
          <VueMultiselect
            v-if="renderyear"
            style="width: 80px; padding-left: 15px"
            v-model="currentYear"
            placeholder="Year"
            tag-placeholder=""
            :options="years"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            :show-pointer="true"
            :show-arrow="true"
            @select="handleYearSelect"
          >
          </VueMultiselect>
        </div>
      </div>
    </div>
    <template v-if="rendering && result">
      <div v-if="loading">
        <SpinnerLoading></SpinnerLoading>
      </div>
      <div style="padding: 0px 30px" v-else>
        <div class="section-header">{{ "Summary Results" }}</div>
        <div class="row">
          <div class="col-2" v-for="(card, index) in cards" :key="index">
            <div class="blue-border"></div>

            <div class="overivew-card">
              <img
                :src="require(`@/assets/images/${card.icon}`)"
                alt
                class="card-img"
              />
              <div class="card-value">
                {{ calculateRatingTotal(card.card_key) }}
              </div>
              <div class="card-label">{{ card.label }}</div>
            </div>
          </div>
        </div>
        <div class="an-divider" v-if="selectedMonth !== 'All'"></div>
        <div class="an-section" v-if="selectedMonth !== 'All'">
          <div class="section-header2">{{ "Additional Data" }}</div>
          <div
            class="pT20"
            v-if="
              resultData[currentYear] && resultData[currentYear][selectedMonth]
            "
          >
            <switches
              v-model="resultData[currentYear][selectedMonth].additionaldata"
              type-bold="false"
              color="info"
              class="mt-2"
            ></switches>
          </div>
          <div
            v-if="
              resultData[currentYear] &&
              resultData[currentYear][selectedMonth] &&
              resultData[currentYear][selectedMonth].additionaldata
            "
          >
            <div class="feedback-table">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="rating in ratings" :key="rating">
                      {{ rating }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody v-if="resultData[currentYear][selectedMonth]">
                  <tr
                    v-for="(counts, method) in resultData[currentYear][
                      selectedMonth
                    ].feedbackData"
                    :key="method"
                  >
                    <template v-if="method !== 'Other'">
                      <td>{{ method }}</td>
                      <td v-for="(rating, key) in ratings" :key="key">
                        <div>
                          <input
                            class="an-input"
                            type="number"
                            @change="calculateTotal()"
                            v-model="counts[key]"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="an-total">
                          {{ counts.total }}
                        </div>
                      </td>
                    </template>
                  </tr>
                  <tr>
                    <td>{{ "Patient Link Website" }}</td>
                    <template v-for="(rating, key) in patientLinkWebsiteResult">
                      <td :key="key" v-if="key !== 'total'">
                        <div>
                          <input
                            class="an-input disabled"
                            type="number"
                            v-model="patientLinkWebsiteResult[key]"
                            :disabled="true"
                          />
                        </div>
                      </td>
                    </template>

                    <td>
                      <div class="an-total">
                        {{ patientLinkWebsiteResult.total }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(counts, method) in resultData[currentYear][
                      selectedMonth
                    ].feedbackData"
                    :key="`${method}1`"
                  >
                    <template v-if="method === 'Other'">
                      <td>{{ method }}</td>
                      <td v-for="(rating, key) in ratings" :key="key">
                        <div>
                          <input
                            class="an-input"
                            type="number"
                            @change="calculateTotal()"
                            v-model="counts[key]"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="an-total">
                          {{ counts.total }}
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <button
            class="btn btn-primary mt-5 px-4"
            type="submit"
            style="border-radius: 0"
            @click="updateAnalyticsResultData()"
          >
            SAVE
          </button>
        </div>
        <div class="an-divider"></div>
        <div class="an-section">
          <div class="section-header">{{ "Summary Scores" }}</div>
          <div class="chart-section">
            <div class="chart-container">
              <GaugeChart :progress="recommended" color="#22b14c"></GaugeChart>
              <div class="an-title">{{ "Recommended" }}</div>
            </div>
            <div class="an-v-divider"></div>
            <div class="chart-container">
              <GaugeChart
                :progress="notRecommended"
                color="#da3f3f"
              ></GaugeChart>
              <div class="an-title">{{ "Not Recommended" }}</div>
            </div>
            <div class="an-v-divider"></div>
            <div class="chart-container">
              <GaugeChart :progress="passive" color="#949ca8"></GaugeChart>
              <div class="an-title">{{ "Passive" }}</div>
            </div>
          </div>
        </div>
        <div class="an-divider"></div>
        <div class="an-section">
          <div class="section-header">{{ "Demographics" }}</div>
          <div class="flex">
            <div class="mini-chart-conatiner">
              <div class="">
                <GenderPieChart
                  :chartData="filteredFFTResults"
                ></GenderPieChart>
                <div class="an-title2" style="width: 350px">{{ "Gender" }}</div>
              </div>
            </div>
            <div class="an-v2-divider"></div>

            <div class="mini-chart-conatiner">
              <div
                class=""
                style="width: 430px; height: 400px; padding: 0px 20px"
              >
                <HorizontalBarChart
                  :chartData="filteredFFTResults"
                ></HorizontalBarChart>
                <div class="an-title2">{{ "Age Groups" }}</div>
              </div>
            </div>

            <div class="mini-chart-conatiner">
              <div class="an-v2-divider"></div>

              <div class="" style="width: 100%">
                <PieChart :chartData="filteredFFTResults"></PieChart>
                <div class="an-title2">{{ "Patient Type" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="an-divider"></div>
        <div class="an-section">
          <div class="section-header">{{ "Day of the Week Analysis" }}</div>
          <div class="row">
            <div class="col-6">
              <div class="">
                <DayOfWeekBarChartVue
                  :chartData="filteredFFTResults"
                ></DayOfWeekBarChartVue>
              </div>
            </div>
          </div>
        </div>
        <template v-if="selectedMonth !== 'All'">
          <div class="an-divider"></div>
          <div class="an-section">
            <div class="section-header">
              {{ "Dates of the Month Analysis" }}
            </div>
            <div class="row">
              <div class="col-12">
                <div class="">
                  <DatesOfMonthBarChart
                    :chartData="filteredFFTResults"
                    :month="currentMonthInt"
                    :year="currentYear"
                  ></DatesOfMonthBarChart>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="selectedMonth === 'All'">
          <div class="an-divider"></div>
          <div class="an-section">
            <div class="section-header">
              {{ "Dates of the Month Analysis" }}
            </div>
            <div class="row">
              <div class="col-12">
                <div class="">
                  <DatesOfMonthBarChartYear
                    :chartData="filteredFFTResults"
                    :month="currentMonthInt"
                    :year="currentYear"
                  ></DatesOfMonthBarChartYear>
                </div>
              </div>
            </div>
          </div>
          <div class="an-section">
            <div class="section-header">
              {{ "Months of the Year Analysis" }}
            </div>
            <div class="row">
              <div class="col-12">
                <div class="">
                  <MonthsOfYearBarChart
                    :chartData="filteredFFTResults"
                    :month="currentMonthInt"
                    :year="currentYear"
                  ></MonthsOfYearBarChart>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="an-divider"></div>
        <div class="an-section">
          <div class="row">
            <div class="col-3">
              <div class="d-flex">
                <div class="p10">
                  <img
                    :src="require(`@/assets/images/tick_gray2.svg`)"
                    alt
                    class="icon-2"
                  />
                </div>
                <div class="px-10 color-dark">Consent to publish comment</div>
              </div>
            </div>
            <div class="col-4">
              <div class="d-flex">
                <div class="p10">
                  <img
                    :src="require(`@/assets/images/cross_gray2.svg`)"
                    alt
                    class="icon-3"
                  />
                </div>
                <div class="px-10 color-dark">
                  No consent to publish comment
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-tabs type="card" class="comments-tab" v-model="activeTab">
          <el-tab-pane name="original" label="Original Comments">
            <div>
              <div>
                <div
                  class="an-section"
                  v-if="
                    !recommendedcomments.length &&
                    !notrecommendedcomments.length &&
                    !passivecomments.length
                  "
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex">
                        <div class="p10">
                          <!-- <img
                  :src="require(`@/assets/images/cross_gray2.svg`)"
                  alt
                  class="icon-3"
                /> -->
                        </div>
                        <div class="px-10 no-comments">
                          <div>No Comments Found</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="an-section" v-if="recommendedcomments.length">
                  <div class="section-header">{{ "Recommended" }}</div>
                  <div class="row coment-section">
                    <div
                      class="col-12"
                      v-for="(d, index) in recommendedcomments"
                      :key="index"
                    >
                      <div class="coment-container">
                        <div class="p10">
                          <img
                            v-if="d.isPublic"
                            :src="require(`@/assets/images/tick_green.svg`)"
                            alt
                            class="icon-2"
                          />
                          <img
                            v-else
                            :src="require(`@/assets/images/cross_green.svg`)"
                            alt
                            class="icon-3"
                          />
                        </div>
                        <div class="px-10 comment-content">
                          <div>{{ d.comments }}</div>
                          <div class="comment-timestamp">
                            {{ formatCommentDate(d.dateTime) }}
                          </div>
                        </div>
                        <div
                          v-if="isDuplicate(d)"
                          class="delete-duplicate"
                          @click="deleteDuplicate(d)"
                          title="Delete this duplicate"
                        >
                          <i class="ri-delete-bin-line"></i>
                        </div>
                      </div>
                      <div
                        class="an-divider3"
                        v-if="index !== recommendedcomments.length - 1"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="an-section" v-if="notrecommendedcomments.length">
                  <div class="section-header">{{ "Not Recommended" }}</div>
                  <div class="row coment-section">
                    <div
                      class="col-12"
                      v-for="(d, index) in notrecommendedcomments"
                      :key="index"
                    >
                      <div class="coment-container">
                        <div class="p10">
                          <img
                            v-if="d.isPublic"
                            :src="require(`@/assets/images/tick_red.svg`)"
                            alt
                            class="icon-2"
                          />
                          <img
                            v-else
                            :src="require(`@/assets/images/cross_red.svg`)"
                            alt
                            class="icon-3"
                          />
                        </div>
                        <div class="px-10 comment-content">
                          <div>{{ d.comments }}</div>
                          <div class="comment-timestamp">
                            {{ formatCommentDate(d.dateTime) }}
                          </div>
                        </div>
                        <div
                          v-if="isDuplicate(d)"
                          class="delete-duplicate"
                          @click="deleteDuplicate(d)"
                          title="Delete this duplicate"
                        >
                          <i class="ri-delete-bin-line"></i>
                        </div>
                      </div>
                      <div
                        class="an-divider3"
                        v-if="index !== notrecommendedcomments.length - 1"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="an-section" v-if="passivecomments.length">
                  <div class="section-header">{{ "Passive" }}</div>
                  <div class="row coment-section">
                    <div
                      class="col-12"
                      v-for="(d, index) in passivecomments"
                      :key="index"
                    >
                      <div class="coment-container">
                        <div class="p10">
                          <img
                            v-if="d.isPublic"
                            :src="require(`@/assets/images/tick_gray.svg`)"
                            alt
                            class="icon-2"
                          />
                          <img
                            v-else
                            :src="require(`@/assets/images/cross_gray.svg`)"
                            alt
                            class="icon-3"
                          />
                        </div>
                        <div class="px-10 comment-content">
                          <div>{{ d.comments }}</div>
                          <div class="comment-timestamp">
                            {{ formatCommentDate(d.dateTime) }}
                          </div>
                        </div>
                        <div
                          v-if="isDuplicate(d)"
                          class="delete-duplicate"
                          @click="deleteDuplicate(d)"
                          title="Delete this duplicate"
                        >
                          <i class="ri-delete-bin-line"></i>
                        </div>
                      </div>
                      <div
                        class="an-divider3"
                        v-if="index !== passivecomments.length - 1"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane name="summary" label="Summary">
            <div>
              <div>
                <!-- <h2>
            Summaries for:
            <span style="text-transform: capitalize">{{ selectedMonth }}</span>
            {{ currentYear }}
          </h2> -->

                <div class="an-section summarized-comments-section">
                  <!-- <div class="section-header">Summarized Patient Feedback</div> -->

                  <div v-if="selectedSummaryData" class="summaries-container">
                    <div
                      v-if="selectedSummaryData.status === 'Error'"
                      class="summary-error"
                      style="
                        padding: 10px;
                        border: 1px solid orange;
                        background-color: #fff3e0;
                        color: #e65100;
                        margin-bottom: 15px;
                        border-radius: 4px;
                      "
                    >
                      <strong>Processing Error:</strong>
                      {{
                        selectedSummaryData.error ||
                        "An error occurred during backend processing."
                      }}
                      <br />
                      <span style="font-size: 12px; color: #777">
                        Last Attempt:
                        <!-- {{ formatTimestamp(selectedSummaryData.lastUpdated) }} -->
                      </span>
                    </div>
                    <div
                      v-else-if="selectedSummaryData.status === 'No comments'"
                      class="summary-info"
                      style="
                        color: grey;
                        margin-bottom: 10px;
                        font-style: italic;
                      "
                    >
                      No comments were found for this period.
                      <br />
                      <span style="font-size: 12px; color: #777">
                        Last Checked:
                        <!-- {{ formatTimestamp(selectedSummaryData.lastUpdated) }} -->
                      </span>
                    </div>
                    <div
                      v-else-if="
                        selectedSummaryData.status === 'No new comments'
                      "
                      class="summary-info"
                      style="
                        color: grey;
                        margin-bottom: 10px;
                        font-style: italic;
                      "
                    >
                      No *new* comments were processed in the last run for this
                      period. Existing data shown.
                      <br />
                      <span style="font-size: 12px; color: #777">
                        Last Run:
                        <!-- {{ formatTimestamp(selectedSummaryData.lastUpdated) }} -->
                      </span>
                    </div>
                    <div
                      v-else-if="
                        selectedSummaryData.status &&
                        selectedSummaryData.status !== 'Processed'
                      "
                      class="summary-info"
                      style="color: #555; margin-bottom: 10px"
                    >
                      Status: {{ selectedSummaryData.status }}
                      <br />
                      <span style="font-size: 12px; color: #777">
                        Last Updated:
                        <!-- {{ formatTimestamp(selectedSummaryData.lastUpdated) }} -->
                      </span>
                    </div>

                    <div
                      v-if="selectedSummaryData.status !== 'Error'"
                      class="comment-counts"
                      style="margin-bottom: 15px; font-size: 14px; color: #555"
                    >
                      Analyzed
                      <strong>{{
                        selectedSummaryData.commentCountAnalyzed ?? 0
                      }}</strong>
                      comments:
                      <span style="margin-left: 5px">
                        {{ selectedSummaryData.sentimentCounts?.positive ?? 0 }}
                        Recommended
                      </span>
                      |
                      <span>
                        {{ selectedSummaryData.sentimentCounts?.negative ?? 0 }}
                        Not Recommended
                      </span>
                      |
                      <span>
                        {{ selectedSummaryData.sentimentCounts?.neutral ?? 0 }}
                        Passive
                      </span>
                      <br />
                      <span
                        v-if="selectedSummaryData.status === 'Processed'"
                        style="font-size: 12px; color: #777"
                      >
                        Last Processed:
                        {{ formatTimestamp(selectedSummaryData.lastUpdated) }}
                      </span>
                    </div>

                    <div v-if="selectedSummaryData.status !== 'Error'">
                      <div class="section-header">{{ "Recommended" }}</div>

                      <div class="summary-block positive-summary">
                        <p
                          class="summary-text"
                          style="
                            font-size: 14px;
                            line-height: 1.7;
                            white-space: pre-wrap;
                          "
                        >
                          {{
                            selectedSummaryData.positiveSummary ||
                            "No positive summary available."
                          }}
                        </p>
                      </div>
                      <div class="section-header">{{ "Not Recommended" }}</div>

                      <div
                        class="summary-block negative-summary"
                        style="margin-top: 15px"
                      >
                        <p
                          class="summary-text"
                          style="
                            font-size: 14px;
                            line-height: 1.7;
                            white-space: pre-wrap;
                          "
                        >
                          {{
                            selectedSummaryData.negativeSummary ||
                            "No negative summary available."
                          }}
                        </p>
                      </div>
                      <div class="section-header">{{ "Passive" }}</div>

                      <div
                        class="summary-block neutral-summary"
                        style="margin-top: 15px"
                      >
                        <p
                          class="summary-text"
                          style="
                            font-size: 14px;
                            line-height: 1.7;
                            white-space: pre-wrap;
                          "
                        >
                          {{
                            selectedSummaryData.neutralSummary ||
                            "No neutral summary available."
                          }}
                        </p>
                      </div>

                      <div
                        v-if="
                          selectedSummaryData.error &&
                          selectedSummaryData.status !== 'Error'
                        "
                        class="summary-error"
                        style="margin-top: 15px; color: orange; font-size: 13px"
                      >
                        <strong>Processing Note:</strong>
                        {{ selectedSummaryData.error }}
                      </div>
                    </div>
                  </div>

                  <div
                    v-else
                    class="no-summary-data"
                    style="padding: 20px; text-align: center; color: #777"
                  >
                    No summary data has been generated for
                    <span style="text-transform: capitalize">{{
                      selectedMonth
                    }}</span>
                    {{ currentYear }} yet.
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- Duplicates Tab - Only shown when duplicates exist -->
          <el-tab-pane
            v-if="hasDuplicates"
            name="duplicates"
            :label="`Duplicates (${duplicateGroups.length} groups)`"
          >
            <div class="duplicates-section">
              <div class="duplicates-info">
                <p>
                  <i class="ri-information-line"></i>
                  The following comments appear to be duplicates (same text
                  submitted multiple times). Click "Delete Duplicates" to remove
                  the newer copies and keep the original.
                </p>
              </div>

              <div
                v-for="(group, idx) in duplicateGroups"
                :key="idx"
                class="duplicate-group"
              >
                <div class="group-header">
                  <span class="group-title">
                    <i class="ri-file-copy-line"></i>
                    Group {{ idx + 1 }} - {{ group.comments.length }} duplicate
                    comments
                  </span>
                  <button
                    class="btn btn-danger btn-sm delete-group-btn"
                    @click="deleteDuplicateGroup(group)"
                    :disabled="deletingDuplicates"
                  >
                    <i class="ri-delete-bin-line"></i>
                    Delete Duplicates ({{ group.comments.length - 1 }})
                  </button>
                </div>

                <div class="group-comments">
                  <div
                    v-for="(comment, cIdx) in group.comments"
                    :key="comment.id || cIdx"
                    class="duplicate-comment"
                    :class="{
                      'keep-comment': cIdx === 0,
                      'delete-comment': cIdx !== 0,
                    }"
                  >
                    <div class="comment-badge">
                      <span v-if="cIdx === 0" class="badge badge-success">
                        <i class="ri-check-line"></i> Keep (Oldest)
                      </span>
                      <span v-else class="badge badge-danger">
                        <i class="ri-delete-bin-line"></i> Will Delete
                      </span>
                    </div>
                    <div class="comment-text">{{ comment.comments }}</div>
                    <div class="comment-meta">
                      <span class="timestamp">
                        <i class="ri-time-line"></i>
                        {{ formatCommentDate(comment.dateTime) }}
                      </span>
                      <span class="rating">
                        <i class="ri-star-line"></i>
                        {{ getRatingLabel(comment.exp) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="margin-bottom-space"></div>
      </div>
    </template>
  </div>
</template>
<script>
import Switches from "vue-switches";
import GaugeChart from "./GaugeChart.vue";
import PieChart from "./PieChart.vue";
import GenderPieChart from "./GenderPieChart.vue";
import DatesOfMonthBarChart from "./DatesOfMonthBarChart.vue";
import DatesOfMonthBarChartYear from "./DatesOfMonthBarChartYear.vue";
import MonthsOfYearBarChart from "./MonthsOfYearBarChart.vue";
import DayOfWeekBarChartVue from "./DayOfWeekBarChart.vue";
import HorizontalBarChart from "./HorizontalBarChart.vue";
import VueMultiselect from "vue-multiselect";
import _ from "lodash";
import api from "../../../api";
import Swal from "sweetalert2";
import { isNumber } from "@turf/turf";
import SpinnerLoading from "./SpinnerLoading.vue";

export default {
  components: {
    Switches,
    GaugeChart,
    PieChart,
    DatesOfMonthBarChart,
    VueMultiselect,
    HorizontalBarChart,
    GenderPieChart,
    DayOfWeekBarChartVue,
    SpinnerLoading,
    MonthsOfYearBarChart,
    DatesOfMonthBarChartYear,
  },
  computed: {
    selectedSummaryData() {
      console.log(
        "this.fftResultsCategory?.additionalProp1?.monthlySummaries",
        this.fftResultsCategory.additionalProp1.monthlySummaries,
        this.currentYear,
        this.selectedMonth
      );
      if (
        !this.fftResultsCategory?.additionalProp1?.monthlySummaries ||
        !this.currentYear ||
        !this.selectedMonth
      ) {
        console.warn(
          "Summary data prerequisites not met:",
          this.fftResultsCategory,
          this.currentYear,
          this.selectedMonth
        );
        return null;
      }
      try {
        const yearData =
          this.fftResultsCategory.additionalProp1.monthlySummaries[
            this.currentYear
          ];
        if (!yearData) {
          console.log(`No data found for year ${this.currentYear}`);
          return null;
        }
        // Access the data for the specific month OR the 'all' key
        const periodData = yearData[this.selectedMonth];
        if (!periodData) {
          console.log(
            `No data found for period ${this.selectedMonth} in year ${this.currentYear}`
          );
          return null;
        }
        // console.log(`Data found for ${this.selectedMonth} ${this.currentYear}:`, periodData);
        return periodData;
      } catch (e) {
        console.error("Error accessing summary data:", e);
        return null;
      }
    },
    getCMSId() {
      return this.$route.params.cmsId;
    },
    getOptions() {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth(); // 0 = January, 8 = September

      if (currentYear === 2024) {
        // Array of months starting from September to December

        const months = {
          8: ["September"],
          9: ["September", "October"],
          10: ["September", "October", "November"],
          11: ["September", "October", "November", "December"],
        };

        // Return filtered months starting from the current month
        return months[currentMonth];
      }
      // else if (currentYear === 2025) {
      //   // Array of months starting from September to December

      //   const months = {
      //     8: ["September"],
      //   };

      //   // Return filtered months starting from the current month
      //   return months[currentMonth];

      // }

      // Return this.options for other years
      return this.options;
    },
    filteredOptions() {
      const realDate = new Date();
      const realYear = realDate.getFullYear();
      const realMonth = realDate.getMonth();

      if (this.currentYear === 2024) {
        return ["All", ...this.options_2024];
      }

      if (this.currentYear < realYear) {
        return ["All", ...this.options];
      }

      if (this.currentYear === realYear) {
        return ["All", ...this.options.slice(0, realMonth + 1)];
      }

      return ["All", ...this.options];
    },
    years() {
      const startYear = 2024;
      const currentYear = new Date().getFullYear();
      const years = [];
      // Generate years from 2024 up to 'currentYear + 1' or just 'currentYear'
      // User asked for 2026 (current year). Let's go up to currentYear + 1 to be safe or just currentYear.
      // Usually analytics shows up to current year.
      for (let y = startYear; y <= currentYear + 1; y++) {
        years.push(y);
      }
      return years;
    },
    currentMonthInt() {
      let currentYear = new Date().getFullYear();
      return currentYear === 2024
        ? this.getOptions.findIndex((rt) => rt === this.selectedMonth) + 8
        : this.getOptions.findIndex((rt) => rt === this.selectedMonth);
    },
    cardValues() {
      let verygood = this.calculateRatingTotal("VERY_GOOD") || 0;
      let good = this.calculateRatingTotal("GOOD") || 0;
      let neither = this.calculateRatingTotal("NEITHER") || 0;

      let poor = this.calculateRatingTotal("POOR") || 0;

      let verypoor = this.calculateRatingTotal("VERY_POOR") || 0;

      let total = verygood + good + neither + poor + verypoor;

      return { verygood, good, neither, poor, verypoor, total };
    },
    recommended() {
      let { verygood, good, neither, poor, verypoor } = this.cardValues;

      let recommendedNumerator = verygood + good;

      let recommendedDenominator = verygood + good + neither + poor + verypoor;

      let recommendedPercentage =
        (recommendedNumerator / recommendedDenominator) * 100;

      return isNumber(recommendedPercentage)
        ? Number(recommendedPercentage.toFixed(0))
        : 0;
    },
    notRecommended() {
      let { verypoor, poor, verygood, good, neither } = this.cardValues;

      let notRecommendedNumerator = verypoor + poor;

      let total = verygood + good + neither + poor + verypoor;

      let notRecommendedPercentage = (notRecommendedNumerator / total) * 100;

      return isNumber(notRecommendedPercentage)
        ? Number(notRecommendedPercentage.toFixed(2))
        : 0;
    },

    passive() {
      let { neither, verygood, good, poor, verypoor } = this.cardValues;

      let passiveNumerator = neither;

      let total = verygood + good + neither + poor + verypoor;

      let passivePercentage = (passiveNumerator / total) * 100;

      return isNumber(passivePercentage)
        ? Number(passivePercentage.toFixed(2))
        : 0;
    },

    practiceCode() {
      return this.currentPractice?.additionalProp1.dynamo
        ? this.currentPractice.additionalProp1.dynamo
        : null;
    },
    recommendedcomments() {
      let data = [];
      this.filteredFFTResults.forEach((rt) => {
        if (rt.exp === 5) {
          data.push({ ...rt, ...{ isPublic: true } });
        }
        if (rt.exp === 4) {
          data.push({ ...rt, ...{ isPublic: true } });
        }
      });
      return data.filter((rt) => rt.comments !== "");
    },
    notrecommendedcomments() {
      let data = [];
      this.filteredFFTResults.forEach((rt) => {
        if (rt.exp === 2) {
          data.push({ ...rt, ...{ isPublic: true } });
        }
        if (rt.exp === 1) {
          data.push({ ...rt, ...{ isPublic: true } });
        }
      });
      return data.filter((rt) => rt.comments !== "");
    },
    passivecomments() {
      let data = [];
      this.filteredFFTResults.forEach((rt) => {
        if (rt.exp === 3) {
          data.push({ ...rt, ...{ isPublic: true } });
        }
      });
      return data.filter((rt) => rt.comments !== "");
    },
    // Computed property for duplicate groups - auto-updates when filteredFFTResults changes
    duplicateGroups() {
      const commentMap = new Map();

      console.log("=== DUPLICATE DETECTION (Computed) ===");
      console.log(
        "Total filtered FFT results:",
        this.filteredFFTResults.length
      );

      // Group by normalized text
      this.filteredFFTResults.forEach((item) => {
        if (!item.comments || item.comments.trim() === "") return;

        const normalized = this.normalizeComment(item.comments);

        if (!commentMap.has(normalized)) {
          commentMap.set(normalized, []);
        }
        commentMap.get(normalized).push(item);
      });

      console.log("Unique comments found:", commentMap.size);

      // Filter only groups with more than 1 comment (duplicates)
      const groups = [];
      commentMap.forEach((comments, normalizedText) => {
        if (comments.length > 1) {
          // Sort by timestamp ascending (oldest first)
          comments.sort((a, b) => Number(a.dateTime) - Number(b.dateTime));

          groups.push({
            normalizedText,
            comments: comments,
          });
          console.log(
            `Duplicate group found: "${normalizedText.substring(0, 50)}..." (${
              comments.length
            } copies)`
          );
        }
      });

      console.log("Duplicate groups:", groups.length);
      console.log("===========================");

      return groups;
    },
    // Check if any duplicate comments exist
    hasDuplicates() {
      return this.duplicateGroups.length > 0;
    },
    patientLinkWebsiteResult() {
      let total = 0;
      const counts = {
        VERY_GOOD: 0,
        GOOD: 0,
        NEITHER: 0,
        POOR: 0,
        VERY_POOR: 0,
        DONT_KNOW: 0,
      };

      // Use a single iteration to count all categories
      this.filteredFFTResults.forEach((rt) => {
        switch (rt.exp) {
          case 5:
            counts.VERY_GOOD++;
            break;
          case 4:
            counts.GOOD++;
            break;
          case 3:
            counts.NEITHER++;
            break;
          case 2:
            counts.POOR++;
            break;
          case 1:
            counts.VERY_POOR++;
            break;
          case 0:
            counts.DONT_KNOW++;
            break;
        }
      });

      // Calculate total
      total = Object.values(counts).reduce((acc, cur) => acc + cur, 0);

      return {
        ...counts,
        total: total,
      };
    },
    filteredFFTResults() {
      let odsCode = this.practiceCode;

      if (this.selectedMonth === "All") {
        return this.fftResults.filter((item) => {
          const date = new Date(Number(item.dateTime));
          if (isNaN(date.getTime())) {
            return false;
          }
          const matchesYear = date.getFullYear() === this.currentYear;
          const matchesOdsCode = item.odsCode === odsCode;
          return matchesYear && matchesOdsCode;
        });
      }

      return this.fftResults.filter((item) => {
        // Convert the timestamp to a Date object and validate it
        const date = new Date(Number(item.dateTime));
        if (isNaN(date.getTime())) {
          return false; // Skip this item if the date is invalid
        }

        // Check if the year and month from the Date object match the input

        const matchesYear = date.getFullYear() === this.currentYear;
        const matchesMonth =
          this.options[date.getMonth()] === this.selectedMonth;
        const matchesOdsCode = item.odsCode === odsCode;
        return matchesYear && matchesMonth && matchesOdsCode;
      });
    },
  },
  mounted() {
    if (this.currentPractice?.id) {
      this.init();
    }
    const today = new Date();
    const currentMonth = today.getMonth();
    this.currentYear = today.getFullYear();
    this.selectedMonth = this.options[currentMonth];
  },
  watch: {
    currentPractice(newVal) {
      if (newVal?.id) {
        this.init();
      }
    },
  },
  methods: {
    formatTimestamp(isoString) {
      const date = new Date(isoString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    // Format comment timestamp for display (e.g., "08 Jan 2026, 10:32")
    formatCommentDate(timestamp) {
      const date = new Date(Number(timestamp));
      if (isNaN(date.getTime())) return "";
      const options = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };
      return date.toLocaleDateString("en-GB", options);
    },
    // Get rating label for display
    getRatingLabel(exp) {
      const labels = {
        5: "Very Good",
        4: "Good",
        3: "Neither",
        2: "Poor",
        1: "Very Poor",
        0: "Don't Know",
      };
      return labels[exp] || "";
    },
    // Normalize comment for comparison (case-insensitive, whitespace-trimmed)
    normalizeComment(text) {
      if (!text) return "";
      return text.toLowerCase().replace(/\s+/g, " ").trim();
    },
    // Check if a comment is a duplicate (for showing delete icon in main list)
    isDuplicate(comment) {
      if (!comment.comments) return false;
      const normalized = this.normalizeComment(comment.comments);
      const group = this.duplicateGroups.find(
        (g) => g.normalizedText === normalized
      );
      if (!group) return false;
      // It's a duplicate if it's not the oldest in the group
      return group.comments[0].id !== comment.id;
    },
    // Delete duplicates in a group (keep oldest)
    async deleteDuplicateGroup(group) {
      const confirmed = await Swal.fire({
        title: "Delete Duplicates?",
        text: `This will delete ${
          group.comments.length - 1
        } duplicate comment(s) and keep the original.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete duplicates",
      });

      if (!confirmed.isConfirmed) return;

      this.deletingDuplicates = true;

      try {
        // Keep first (oldest), delete rest
        const toDelete = group.comments.slice(1);

        for (const comment of toDelete) {
          await this.deleteFFTComment(comment.id);
        }

        // Refresh data - duplicateGroups will auto-update as computed property
        await this.getFFTResults();

        Swal.fire(
          "Deleted!",
          "Duplicate comments have been removed.",
          "success"
        );
      } catch (error) {
        console.error("Error deleting duplicates:", error);
        Swal.fire(
          "Error",
          "Failed to delete duplicates. Please try again.",
          "error"
        );
      } finally {
        this.deletingDuplicates = false;
      }
    },
    // Delete single duplicate comment
    async deleteDuplicate(comment) {
      const confirmed = await Swal.fire({
        title: "Delete this duplicate?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete",
      });

      if (!confirmed.isConfirmed) return;

      try {
        await this.deleteFFTComment(comment.id);
        await this.getFFTResults();
        // duplicateGroups will auto-update as computed property
        Swal.fire("Deleted!", "Comment removed.", "success");
      } catch (error) {
        Swal.fire("Error", "Failed to delete. Please try again.", "error");
      }
    },
    // API call to delete a single FFT comment
    async deleteFFTComment(commentId) {
      await api.delete(`/api/analytics-results/fft-comment/${commentId}`);
    },
    filterComments(comments) {
      return comments.filter((rt) => rt.comments !== "");
    },
    async init() {
      this.loading = true;
      await this.getAnalyticsCategory();
      if (this.fftResultsCategory?.additionalProp1?.resultData) {
        await this.getAnalyticsResultData();
      }
      await this.getFFTResults();

      // duplicateGroups is now a computed property - auto-updates

      // Ensure resultData structure exists
      if (!this.resultData) {
        this.resultData = {};
      }
      if (!this.resultData[this.currentYear]) {
        this.resultData[this.currentYear] = {};
      }
      // Ensure selected month data exists
      if (!this.resultData[this.currentYear][this.selectedMonth]) {
        this.resultData[this.currentYear][this.selectedMonth] = this.clone(
          this.emptyData
        );
      }

      this.calculateTotal();
      this.loading = false;
    },
    isObjectChanged() {
      console.log(
        "_.isEqual(this.result, this.previusResult);",
        this.previusResult,
        this.result,
        _.isEqual(this.result, this.previusResult)
      );
      return !_.isEqual(this.result, this.previusResult);
    },
    async getAnalyticsCategory() {
      const response = await api.get(`/api/cms/${this.getCMSId}/categories`);
      this.fftResultsCategory = response.data.find(
        (rt) => rt.name === "fftresults"
      );
    },
    async getAnalyticsResultData() {
      try {
        const data = this.fftResultsCategory.additionalProp1;

        if (data?.resultData) {
          // Load all years data, not just current year
          this.resultData = data.resultData;

          // Calculate "All" for each year that has data
          Object.keys(this.resultData).forEach((year) => {
            this.calculateAllForYear(Number(year));
          });
        }
        this.result = data;
        this.previusResult = this.clone(data);
      } catch (e) {
        console.log(e);
      }
    },
    calculateAllForYear(year) {
      const allData = {
        additionaldata: false,
        feedbackData: {
          Handwritten: {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Telephone Call": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Tablet / Kiosk": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "SMS / Text Message": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Smartphone app or online": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          Other: {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
        },
      };

      if (!this.resultData || !this.resultData[year]) {
        return;
      }

      Object.keys(this.resultData[year]).forEach((month) => {
        if (month !== "All") {
          const monthData = this.resultData[year][month];

          if (monthData && monthData.feedbackData) {
            Object.keys(monthData.feedbackData).forEach((type) => {
              if (allData.feedbackData[type]) {
                const typeData = monthData.feedbackData[type];
                allData.feedbackData[type].VERY_GOOD += Number(
                  typeData?.VERY_GOOD || 0
                );
                allData.feedbackData[type].GOOD += Number(typeData?.GOOD || 0);
                allData.feedbackData[type].NEITHER += Number(
                  typeData?.NEITHER || 0
                );
                allData.feedbackData[type].POOR += Number(typeData?.POOR || 0);
                allData.feedbackData[type].VERY_POOR += Number(
                  typeData?.VERY_POOR || 0
                );
                allData.feedbackData[type].DONT_KNOW += Number(
                  typeData?.DONT_KNOW || 0
                );
                allData.feedbackData[type].total += Number(
                  typeData?.total || 0
                );
              }
            });
          }
        }
      });

      this.resultData[year]["All"] = allData;
    },

    // async getAnalyticsResultData() {
    //   let url = `/api/analytics-results/${this.$store.state.currentPractice.id}`;
    //   try {
    //     const { data } = await api.get(url);

    //     if (data?.resultData && data.resultData[this.currentYear]) {
    //       this.resultData = data.resultData;
    //       const allData = {
    //         additionaldata: false,
    //         feedbackData: {
    //           Handwritten: {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //           "Telephone Call": {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //           "Tablet / Kiosk": {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //           "SMS / Text Message": {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //           "Smartphone app or online": {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //           Other: {
    //             VERY_GOOD: 0,
    //             GOOD: 0,
    //             NEITHER: 0,
    //             POOR: 0,
    //             VERY_POOR: 0,
    //             DONT_KNOW: 0,
    //             total: 0,
    //           },
    //         },
    //       };

    //       Object.keys(data.resultData[this.currentYear]).forEach((month) => {
    //         console.log("month", month);
    //         if (this.filteredOptions.includes(month)) {
    //           const monthData = data.resultData[this.currentYear][month];

    //           if (monthData && monthData.feedbackData) {
    //             Object.keys(monthData.feedbackData).forEach((type) => {
    //               const typeData = monthData.feedbackData[type];
    //               allData.feedbackData[type].VERY_GOOD += Number(
    //                 typeData?.VERY_GOOD || 0
    //               );
    //               allData.feedbackData[type].GOOD += Number(
    //                 typeData?.GOOD || 0
    //               );
    //               allData.feedbackData[type].NEITHER += Number(
    //                 typeData?.NEITHER || 0
    //               );
    //               allData.feedbackData[type].POOR += Number(
    //                 typeData?.POOR || 0
    //               );
    //               allData.feedbackData[type].VERY_POOR += Number(
    //                 typeData?.VERY_POOR || 0
    //               );
    //               allData.feedbackData[type].DONT_KNOW += Number(
    //                 typeData?.DONT_KNOW || 0
    //               );
    //               allData.feedbackData[type].total += Number(
    //                 typeData?.total || 0
    //               );
    //             });
    //           }
    //         }
    //       });

    //       data.resultData[this.currentYear]["All"] = allData;
    //     }
    //     this.result = data;
    //     this.previusResult = this.clone(data);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },

    async getFFTResults() {
      let url = `/api/analytics-results/getFFtresults/${this.practiceCode}`;

      try {
        const { data } = await api.get(url);
        this.fftResults = data || [];
      } catch (error) {
        console.error("Error fetching FFT results", error);
      }
    },
    async updateAnalyticsResultData() {
      try {
        this.fftResultsCategory.additionalProp1["resultData"] =
          this.result.resultData;
        await api.patch(
          `/api/categories/${this.fftResultsCategory.id}`,
          this.fftResultsCategory
        );
        Swal.fire("Data Updated!", "Data Updated Successfully!", "success");
      } catch (e) {
        console.log(e);
      }
    },

    // async updateAnalyticsResultData() {
    //   let url = `/api/analytics-results/${this.result.id}`;
    //   try {
    //     await api.patch(url, this.result);
    //     Swal.fire("Data Updated!", "Data Updated Successfully!", "success");
    //     this.previusResult = this.clone(this.result);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    clone(field) {
      return _.cloneDeep(field);
    },
    handleSelect(val) {
      console.log("result data", this.resultData, this.filteredOptions);

      this.rendering = false;

      // Ensure resultData and year exist before accessing
      if (!this.resultData) {
        this.resultData = {};
      }
      if (!this.resultData[this.currentYear]) {
        this.resultData[this.currentYear] = {};
      }

      // If "All" is selected, calculate consolidated data
      if (val === "All") {
        this.calculateAllYearData();
      } else if (val && !this.resultData[this.currentYear][val]) {
        this.resultData[this.currentYear][val] = this.clone(this.emptyData);
      }

      this.$nextTick(() => {
        this.rendering = true;
      });
    },
    handleYearSelect() {
      console.log("result data", this.resultData, this.filteredOptions);

      this.rendering = false;

      // Ensure resultData and year exist before accessing
      if (!this.resultData) {
        this.resultData = {};
      }
      if (!this.resultData[this.currentYear]) {
        this.resultData[this.currentYear] = {};
      }

      // Calculate "All" consolidated data for the selected year
      this.calculateAllYearData();

      this.rendermonth = false;

      // Set default month based on year
      if (this.currentYear === 2024) {
        this.selectedMonth = "September";
      } else {
        this.selectedMonth = "January";
      }

      // Ensure the selected month data exists
      if (!this.resultData[this.currentYear][this.selectedMonth]) {
        this.resultData[this.currentYear][this.selectedMonth] = this.clone(
          this.emptyData
        );
      }

      this.$nextTick(() => {
        this.rendering = true;
        this.rendermonth = true;
      });
      console.log("selectedMonth", this.selectedMonth, this.currentYear);
    },
    calculateAllYearData() {
      // Wrapper method to calculate All for current year
      this.calculateAllForYear(this.currentYear);
    },
    calculateTotal() {
      // Guard against undefined data
      if (
        !this.resultData ||
        !this.resultData[this.currentYear] ||
        !this.resultData[this.currentYear][this.selectedMonth] ||
        !this.resultData[this.currentYear][this.selectedMonth].feedbackData
      ) {
        return;
      }

      Object.values(
        this.resultData[this.currentYear][this.selectedMonth].feedbackData
      ).forEach((feedback) => {
        feedback.total = 0; // Reset total to zero before calculation
        Object.keys(feedback).forEach((key) => {
          if (key !== "total") {
            feedback.total += Number(feedback[key]); // Add each number to total
          }
        });
      });
    },
    calculateRatingTotal(ratingKey) {
      let total = 0;

      if (
        this.resultData &&
        this.resultData[this.currentYear] &&
        this.resultData[this.currentYear][this.selectedMonth] &&
        this.resultData[this.currentYear][this.selectedMonth].feedbackData
      ) {
        // Loop through each category in feedbackData
        Object.values(
          this.resultData[this.currentYear][this.selectedMonth].feedbackData
        ).forEach((category) => {
          if (category[ratingKey] !== undefined) {
            total += Number(category[ratingKey]); // Sum up the specified rating across all categories
          }
        });
      }
      if (
        this.patientLinkWebsiteResult &&
        this.patientLinkWebsiteResult[ratingKey]
      ) {
        total = total + this.patientLinkWebsiteResult[ratingKey];
      }
      return total;
    },
  },
  data() {
    return {
      activeTab: "original",
      fftResultsCategory: null,
      rendermonth: true,
      renderyear: true,
      loading: true,
      fftResults: [],
      rendering: true,
      selectedMonth: "May",
      currentYear: new Date().getFullYear(),
      // Duplicate detection
      deletingDuplicates: false,
      options: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      options_2024: ["September", "October", "November", "December"],
      ratings: {
        VERY_GOOD: "Very Good",
        GOOD: "Good",
        NEITHER: "Neither",
        POOR: "Poor",
        VERY_POOR: "Very Poor",
        DONT_KNOW: "Don’t know",
      },
      emptyData: {
        additionaldata: true,
        feedbackData: {
          Handwritten: {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Telephone Call": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Tablet / Kiosk": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "SMS / Text Message": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          "Smartphone app or online": {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
          Other: {
            VERY_GOOD: 0,
            GOOD: 0,
            NEITHER: 0,
            POOR: 0,
            VERY_POOR: 0,
            DONT_KNOW: 0,
            total: 0,
          },
        },
      },
      previusResult: null,
      result: null,
      resultData: {},
      cards: [
        {
          icon: "verygood.svg",
          label: "Very good",
          card_key: "VERY_GOOD",
        },
        {
          icon: "good.svg",
          label: "Good",
          card_key: "GOOD",
        },
        {
          icon: "nither.svg",
          label: "Neither good nor poor",
          card_key: "NEITHER",
        },
        {
          icon: "poor.svg",
          label: "Poor",
          card_key: "POOR",
        },
        {
          icon: "verypoor.svg",
          label: "Very Poor",
          card_key: "VERY_POOR",
        },
        {
          icon: "others.svg",
          label: "Don’t know",
          card_key: "DONT_KNOW",
        },
      ],
    };
  },
};
</script>
<style scoped>
.an-divider {
  background: #dadce3;
  margin: 40px 0px;
  height: 1px;
}
.an-v-divider {
  background: #dadce3;
  margin: 0px 40px;
  width: 1px;
}
.an-v2-divider {
  background: #dadce3;
  margin: 50px 10px;
  width: 1px;
}
.an-divider3 {
  background: #dadce3;
  margin: 10px 0px;
  height: 1px;
  margin-top: 5px;
}
.blue-border {
  height: 4px;
  background-color: #005eb8;
  width: 100%;
  position: relative;
}
.section-header {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #333;
  margin: 30px 0px;
}
.section-header2 {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #333;
  margin: 0px 0px;
}
.card-img {
  width: 44px;
  height: 44px;
  margin: 10px 0px;
}
.overivew-card {
  background: #fff;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-around;
  align-items: center;
}
.card-value {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #005eb8;
  margin: 10px 0px;
}
.card-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  margin: 10px 0px;
}
.an-section {
  margin: 10px 0px;
}
.pT20 {
  padding-top: 20px;
}
.feedback-table table {
  width: 100%;
  border-collapse: collapse;
}
.feedback-table td {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #333;
}

.feedback-table th {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333;
}
.an-input {
  padding: 5px 15px;
  border-radius: 4px;
  border: solid 1px #dadce3;
  background-color: #fff;
  margin: 3px;
  width: 93%;
}
.feedback-table td:first-child {
  min-width: 250px;
}

.feedback-table td:last-child {
  text-align: right;
}
.feedback-table th:last-child {
  text-align: right;
}
.an-total {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: #333;
}
.chart-container {
  display: flex;
  align-content: stretch;
  /* flex-wrap: nowrap; */
  align-items: center;
}
.flex-row {
  flex-direction: row;
}
.an-title {
  margin-left: 20px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
}
.an-title2 {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
  text-align: center;
}
.chart-section {
  display: flex;
}
.icon-2 {
  width: 15px;
  height: 15px;
}
.icon-3 {
  width: 12px;
  height: 12px;
}
.d-flex {
  display: flex;
}
.px-10 {
  padding: 0px 10px;
}
.coment-container {
  background: #fff;
  display: flex;
  padding: 10px 0px;
  color: #000;
}
.coment-section {
  background: #fff;
  padding: 10px;
  margin: 0px;
}
.border-bottom-dark {
  border-bottom: 1px solid #dadce3;
}
input.an-input.disabled {
  background: #dadce3;
  cursor: not-allowed;
}
.mini-chart-conatiner {
  width: 32%;
  display: flex;
}
.flex {
  display: flex;
}
.multiselect__select {
  z-index: 1;
}
.no-comments {
  height: 200px;
  width: 100%;
  background: #fff;
  padding: 20px;
  margin-bottom: 100px;
  text-align: center;
  align-content: space-around;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
</style>
<style>
.analytics-result-container .multiselect__select:before {
  position: absolute !important;
  top: 12px;
  right: 13px;
}
.analytics-result-container .multiselect__single {
  max-width: 80%;
}
.color-dark {
  color: #000;
}
.margin-bottom-space {
  margin-bottom: 100px;
}
.summarized-comments-section .section-header {
  /* font-size: 18px;
  font-weight: bold; */
  margin-bottom: 10px;
}
.summary-block {
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 2px;
  background-color: #f9f9f9;
}
.summary-text {
  white-space: pre-wrap; /* Preserve line breaks from the summary */
}
.comments-tab .el-tabs__item.is-active {
  background: #fff !important;
  color: #000 !important;
  border-bottom: 2px solid #005eb8 !important;
  border-bottom-color: #005eb8 !important;
}
.comments-tab .el-tabs__item {
  background: transparent;
  color: #000;
  border-bottom: none;
}
.comments-tab .el-tabs__content {
  padding: 10px;
}
.comments-tab .el-tabs__header {
  margin: 0px;
}
.comments-tab {
  margin-top: 40px;
}

/* Comment Timestamp Styles */
.comment-timestamp {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
}

.comment-content {
  flex: 1;
}

/* Delete Duplicate Icon in Main List */
.delete-duplicate {
  cursor: pointer;
  color: #dc3545;
  padding: 5px 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.delete-duplicate:hover {
  color: #a71d2a;
}

/* Duplicates Tab Styles */
.duplicates-section {
  padding: 20px;
}

.duplicates-info {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 25px;
}

.duplicates-info p {
  margin: 0;
  color: #856404;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.duplicates-info i {
  font-size: 18px;
  margin-top: 2px;
}

.duplicate-group {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.group-header {
  background: #f8f9fa;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.group-title {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-title i {
  font-size: 18px;
  color: #666;
}

.delete-group-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 4px;
}

.delete-group-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.group-comments {
  padding: 0;
}

.duplicate-comment {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}

.duplicate-comment:last-child {
  border-bottom: none;
}

.duplicate-comment.keep-comment {
  background-color: #f8fff8;
  border-left: 3px solid #28a745;
}

.duplicate-comment.delete-comment {
  background-color: #fff8f8;
  border-left: 3px solid #dc3545;
}

.comment-badge {
  margin-bottom: 10px;
}

.comment-badge .badge {
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.comment-badge .badge-success {
  background-color: #28a745;
  color: #fff;
  border-radius: 4px;
}

.comment-badge .badge-danger {
  background-color: #dc3545;
  color: #fff;
  border-radius: 4px;
}

.comment-text {
  color: #333;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: 8px;
}

.comment-meta {
  font-size: 12px;
  color: #888;
  display: flex;
  gap: 20px;
}

.comment-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.comment-meta i {
  font-size: 14px;
}
</style>
